import { createFileRoute, redirect } from "@tanstack/react-router";

// Renamed to Store Settings.
export const Route = createFileRoute("/admin/consignment/stores-teams/")({
	validateSearch: (search: Record<string, unknown>): { tab?: string } =>
		typeof search.tab === "string" ? { tab: search.tab } : {},
	beforeLoad({ search }) {
		throw redirect({
			to: "/admin/consignment-branch-setting",
			search,
			replace: true,
		});
	},
});
